import type { ISelfieQuery } from "lib/queries/__generated__/SelfieQuery.generated";

export default function checkCanSkipToBlackCheckout(viewer: Exclude<ISelfieQuery["selfie"], null>) {
  if (viewer.isBlack || !viewer.isPremium) {
    return false;
  }
  return viewer.viewerCanPurchaseBlack;
}
